import { render } from "./TestHearStart.vue?vue&type=template&id=33f6559a"
import script from "./TestHearStart.vue?vue&type=script&lang=js"
export * from "./TestHearStart.vue?vue&type=script&lang=js"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__